export const ponudba = [
  {
    id: "kava",
    naslov: "Kava in topli napitki",
    opis:
      "Sveže pripravljena kava, ki zaznamuje jutro in da ritmu dneva prijeten začetek.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/26785372770ddb3237e430ff7816a828.png",
    alt: "Skodelica kave z latte art na leseni mizi v Baru Stanka",
    oznaka: "01",
  },
  {
    id: "osvezilne",
    naslov: "Osvežilne pijače",
    opis:
      "Hladne pijače in mehurčki za popoldanski oddih, ko si zaželite nekaj svežega.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/99e678f32ecc6e628ae350e13ad2e054.png",
    alt: "Hladna kava v visokem kozarcu med zelenjem v Baru Stanka",
    oznaka: "02",
  },
  {
    id: "pivo",
    naslov: "Pivo in barske pijače",
    opis:
      "Klasična barska ponudba za sproščen večer v prijetni družbi, brez hitenja.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/7b425a57f37ef63f9ea4e39b9d2d5ac7.png",
    alt: "Kozarec hladnega točenega piva Union na leseni mizi v Baru Stanka na Ptuju",
    oznaka: "03",
  },
  {
    id: "druzenje",
    naslov: "Trenutki za druženje",
    opis:
      "Prostor, kjer se pogovor ustavi ob dobri pijači in se čas ne meri preveč natančno.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/af7f0104ea9a37538d0897c35b12c2d6.png",
    alt: "Barska pijača s citrono, limeto in meto na leseni mizi med druženjem",
    oznaka: "04",
  },
];